import { apiUrl } from '../config/apiBase';
import { refreshAccessToken } from './refreshAccessToken';
/**
 * Профиль текущего пользователя (GET /api/auth/me).
 */
export async function fetchCurrentUser(jwtToken) {
    const url = apiUrl('/api/auth/me');
    const exec = (t) =>
        fetch(url, {
            headers: { Authorization: `Bearer ${t}` },
            credentials: 'include',
        });

    let res;
    try {
        res = await exec(jwtToken);
    } catch {
        const err = new Error('Сервер недоступен. Запустите backend (npm run dev или npm run backend).');
        err.status = 0;
        throw err;
    }
    if (res.status === 401) {
        const newTok = await refreshAccessToken();
        if (newTok) {
            try {
                res = await exec(newTok);
            } catch {
                const err = new Error('Сервер недоступен. Запустите backend (npm run dev или npm run backend).');
                err.status = 0;
                throw err;
            }
        }
    }
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(typeof data?.message === 'string' ? data.message : 'Unauthorized');
        err.status = res.status;
        throw err;
    }
    if (!data.user) {
        throw new Error('Нет данных пользователя');
    }
    return data.user;
}
